<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>파우치 대량 저장</h1>
      </div>
    </div>
    <div class="contents_wrap" id="contents_wrap">
      <div class="small_title_wrap">
        <h2>파우치 정보</h2>
      </div>
      <div class="box_flex mgt10 mgb10">
        <button type="button" class="mid_btn mr5" @click="sampleDownload" >
          <span><span class="k-icon k-i-download"></span>파우치 샘플 파일</span>
        </button>
        <button type="button" class="mid_btn mr5 w5" @click="clearData" >
          <span>초기화</span>
        </button>
      </div>
      <kendo-grid
          id="pouchBatchGrid"
          ref="pouchBatchGrid"
          class="basic_table mgt10"
          style="cursor: pointer;"
          max-height="'100'"
          :navigatable="true"
          :filterable="false"
          :scrollable="true"
          :reorderable="true"
          :columns="pouchBatchSaveColumns"
          :editable="false"
          :editable-mode="'inline'"
          :editable-confirmation="'해당 파우치 정보를 삭제하시겠습니까?'"
          :selectable="'multiple row'"
          :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>이곳을 클릭 후 Ctrl+V 를 이용해 붙여넣기 가능합니다.</div>' }"
      >
      </kendo-grid>
    </div>
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button class="large_btn" @click="$router.push({name: 'PouchList'})">목록</button>
        </li>
        <li class="w25">
          <button class="large_btn green" @click="onClickSave">저장</button>
        </li>
      </ul>
    </div>
    <excel-upload-result-window
        ref="excelUploadResultWindowRef"
        :resultData="excelUploadResult"
        :uploadData="pouchUploadData"
        @onClose="clearData"
    >
    </excel-upload-result-window>
  </section>
</template>

<script>
import $ from 'jquery'
import EtnersCommonUtil from "@/common/etners.common.util";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

import ExcelUploadResultWindow from "@/components/pouch/ExcelUploadResultWindow";

export default {
  name: "PouchBundleSave",
  components: {ExcelUploadResultWindow},
  mounted() {
    const vm = this
    vm.pouchUploadData = []
    // 붙여넣기 이벤트 할당
    document.getElementById('contents_wrap').addEventListener('paste', vm.getClipBoard)
  },
  methods: {
    getClipBoard (e) {
      const vm = this
      let clipboardData, pastedData = null
      e.stopPropagation()
      e.preventDefault()

      // 윈도우 클립보드 내용 가져오기
      clipboardData = e.clipboardData || window.clipboardData
      pastedData = clipboardData.getData('Text')

      vm.setPouchData(pastedData)
    },
    setPouchData (pastedData) {
      const vm = this
      if (EtnersCommonUtil.isEmpty(pastedData)) {
        return false
      }
      let rows = pastedData.split('\n')
      if (rows.length > 1000) {
        kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
        return false
      }

      let dataSource = vm.$refs.pouchBatchGrid.kendoWidget().dataSource.data()

      let data = []
      let rowNo = dataSource.length + 1
      for (let row of rows){
        let cells = row.split('\t')
        let idx = 0
        if (EtnersCommonUtil.isEmpty(cells[0])) {
          idx = 1
        }
        if (EtnersCommonUtil.isEmpty(cells[0]) && EtnersCommonUtil.isEmpty(cells[1])) {
          continue
        }

        let receiveContents = cells[idx+19]
        if (receiveContents !== undefined) {
          receiveContents = receiveContents.replace('\r', '')
        }
        data.push({
          No: rowNo++,
          contentsScn: cells[idx],
          contentsDesc: cells[idx+1],
          sendFacility: cells[idx+2],
          sendBuilding: cells[idx+3],
          sendFloor: cells[idx+4],
          sendZone: cells[idx+5],
          sendNm: cells[idx+6],
          sendDept: cells[idx+7],
          sendMailAddr: cells[idx+8],
          sendAmpmScn: cells[idx+9],
          sendContents: cells[idx+10],
          receiveFacility: cells[idx+11],
          receiveBuilding: cells[idx+12],
          receiveFloor: cells[idx+13],
          receiveZone: cells[idx+14],
          receiveNm: cells[idx+15],
          receiveDept: cells[idx+16],
          receiMailAddr: cells[idx+17],
          receiveAmpmScn: cells[idx+18],
          receiveContents: receiveContents,
        })
      }
      dataSource = [
          ...dataSource,
          ...data
      ]
      vm.$refs.pouchBatchGrid.kendoWidget().setDataSource(dataSource)
    },
    resetRowNo () {
      const vm = this
      // dataSource.data() 쓰고 싶은데, 그걸로 하면 오류남
      let dataSource = vm.$refs.pouchBatchGrid.kendoWidget().dataSource.options.data
      dataSource.forEach(row => row.No = dataSource.indexOf(row) + 1)
      vm.$refs.pouchBatchGrid.kendoWidget().dataSource.options.data = dataSource
    },
    callSaveApi () {
      const vm = this
      const uploadInfoList = vm.$refs.pouchBatchGrid.kendoWidget().dataSource.options.data
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchBundleUpload.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        uploadInfoList: uploadInfoList,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false

        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        if(resultData.boolResult === false){
          vm.excelUploadResult = resultData
          vm.pouchUploadData = uploadInfoList // 실패한 경우에 사용
          vm.$refs.excelUploadResultWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
          return false
        } else {
          vm.excelUploadResult = resultData
          vm.$refs.excelUploadResultWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
          vm.clearData()
        }
      })
    },
    clearData () {
      const vm = this
      vm.$refs.pouchBatchGrid.kendoWidget().setDataSource([])
    },
    sampleDownload(){
      window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_pouch_excel_upload_form.xlsx`
    },
    onClickSave () {
      const vm = this
      const dataSource = vm.$refs.pouchBatchGrid.kendoWidget().dataSource.data()
      if (dataSource.length < 1) {
        kendo.alert('데이터를 입력해주세요.')
        return false
      }
      kendo.confirm(`${dataSource.length}건의 데이터를 저장하시겠습니까?`).then(() => {
        vm.callSaveApi()
      })
    },
  },
  data () {
    const vm = this
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    return {
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      excelUploadResult: {},
      pouchUploadData: [],

      pouchBatchSaveSchema: {
        model: {
          id: "No",
          fields: {
            No: {editable: false},
            contentsScn: {editable: false},
            contentsDesc: {editable: true},
            sendFacility: {editable: false},
            sendBuilding: {editable: false},
            sendFloor: {editable: false},
            sendZone: {editable: false},
            sendNm: {editable: true},
            sendDept: {editable: true},
            sendMailAddr: {editable: true},
            sendAmpmScn: {editable: false},
            sendContents: {editable: true},
            receiveFacility: {editable: false},
            receiveBuilding: {editable: false},
            receiveFloor: {editable: false},
            receiveZone: {editable: false},
            receiveNm: {editable: true},
            receiveDept: {editable: true},
            receiMailAddr: {editable: true},
            receiveAmpmScn: {editable: false},
            receiveContents: {editable: true},
          }
        }
      },
      pouchBatchSaveColumns: [
        {
          field: 'No',
          title: 'No.',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          sortable: false
        },
        {
          field: 'contentsScn',
          title: '내용',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'contentsDesc',
          title: '물품 내용 설명',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendFacility',
          title: '발신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendBuilding',
          title: '발신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendFloor',
          title: '발신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendZone',
          title: '발신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendMailAddr',
          title: '발신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendAmpmScn',
          title: '발신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'sendContents',
          title: '발신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveFacility',
          title: '수신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveBuilding',
          title: '수신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveFloor',
          title: '수신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveZone',
          title: '수신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveDept',
          title: '수신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiMailAddr',
          title: '수신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveAmpmScn',
          title: '수신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          field: 'receiveContents',
          title: '수신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
        },
        {
          command: [
            {
              name:'destroy',
              className: "small_btn mr10",
              template: kendo.template(`<a class="small_btn k-grid-destroy mr10" style="height:24px;"><span class="k-icon k-i-trash"></span></a>`),
              click: function (e){
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                let removeItem = this.dataItem(tr)

                vm.$refs.pouchBatchGrid.kendoWidget().dataSource.remove(removeItem)
                vm.resetRowNo()
              },
            }
          ],
          width: '8%',
        }
      ],
    }
  }
}
</script>
<style scoped>
</style>